import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react';
import { isMobile } from 'react-device-detect';
import { RACE_DAY_LICENSE } from '../../service/games';
import { UserProfile } from '../../service/social';
import { UserLeaderboard } from '../leaderboardComponents/UserLeaderboard';
import { SocialLinks } from './SocialLinks';

interface ProfileTabsParams {
    userProfile: UserProfile | undefined;
}

export const ProfileTabs: React.FC<ProfileTabsParams> = ({ userProfile }) => {
    return (
        <Tabs className={'profile-tabs'}>
            <TabList className={isMobile ? 'profile-tablist' : 'profile-tablist-browser'}>
                <Tab className={'profile-tab-title'}>Leaderboards</Tab>
                <Tab className={'profile-tab-title'}>Socials</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    {userProfile && (
                        <UserLeaderboard license={RACE_DAY_LICENSE} userProfile={userProfile} />
                    )}
                </TabPanel>
                <TabPanel>
                    {userProfile?.social_media_links &&
                        (Object.values(userProfile.social_media_links).some(
                            (item) => item.is_public === true,
                        ) ||
                            userProfile?.email !== '') && <SocialLinks userProfile={userProfile} />}
                </TabPanel>
            </TabPanels>
        </Tabs>
    );
};
